<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <chain-table-edit
          :table="table"
          :chain="chain"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChainTableEdit from './Overlay/ChainTableEdit.vue';

export default {
  components: {
    ChainTableEdit,
  },
  props: {
    table: {
      type: Object,
      default() {
        return {};
      },
    },
    chain: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
};
</script>

<style></style>
